<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" role="dialog" aria-modal="true" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER (charte : cf-modal-head) ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-safe-2-line"></i></span>
                            <div class="min-w-0">
                                <h4 class="cf-dialog-title truncate">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Gestion de vos caisses</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="toolbar">
                        <div class="toolbar-row">

                            <!-- Recherche -->
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="text" class="search-input" placeholder="Rechercher une caisse..." />
                                <button v-if="searchword" @click="searchword = ''" class="search-clear" type="button">
                                    <i class="ri-close-circle-fill"></i>
                                </button>
                            </div>

                            <div class="toolbar-actions">

                                <!-- Compteur licence -->
                                <span class="set-quota" :class="quota.used >= quota.max ? 'set-quota--full' : ''">
                                    <i class="ri-safe-2-line"></i> <b>{{ quota.used }}</b> / {{ quota.max }} licence(s)
                                </span>

                                <!-- Ajouter -->
                                <button @click="btnajouter" :disabled="quota.used >= quota.max"
                                        :title="quota.used >= quota.max ? 'Limite de licence atteinte' : ''"
                                        class="ti-btn ti-btn-primary-full" type="button">
                                    <i class="ri-add-line align-middle"></i><span>Ajouter</span>
                                </button>

                                <!-- Par page -->
                                <div class="perpage-wrap">
                                    <select v-model="DefaultperPage" class="perpage-select" aria-label="Page Size" title="Affichage">
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                        <option value="200">200</option>
                                        <option value="250">250</option>
                                        <option value="300">300</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line perpage-caret"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ========== TABLE ZONE ========== -->
                    <div class="table-zone">
                        <div class="table-scroll-wrap set-scroll">

                            <table class="set-table">
                                <thead>
                                <tr>
                                    <th class="th" style="width:60px;">N°</th>
                                    <th class="th">Nom caisse</th>
                                    <th class="th">Type de caisse</th>
                                    <th class="th">Créé le</th>
                                    <th class="th th--center" style="width:90px;">Actions</th>
                                </tr>
                                </thead>
                                <tbody>

                                <!-- Data -->
                                <template v-if="filterdatatable.length">
                                    <tr v-for="(datavalue, index) in filterdatatable" :key="index" class="table-row">
                                        <td class="td"><span class="row-number">{{ index + 1 }}</span></td>
                                        <td class="td">
                                            <div style="display:flex;align-items:center;gap:10px;">
                                                <div class="avatar--sm"><i class="ri-safe-2-line"></i></div>
                                                <p style="margin:0;font-weight:500;color:var(--cf-ink-strong);" class="truncate">{{ datavalue.intitulecaisse }}</p>
                                            </div>
                                        </td>
                                        <td class="td"><span class="cf-st cf-st--info">{{ mtypedecaisse(datavalue.typedecaisse) }}</span></td>
                                        <td class="td" style="font-size:0.75rem;">
                                            <span style="display:inline-flex;align-items:center;gap:4px;">
                                                <i class="ri-calendar-line" style="color:var(--cf-faint);"></i>{{ datavalue.creerler }}
                                            </span>
                                        </td>
                                        <td class="td td--center" style="overflow:visible;" @click.stop>
                                            <div class="ti-btn-group" style="position:relative;display:inline-block;">
                                                <button class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]" type="button"
                                                        :aria-expanded="openMenu === 'row_' + index"
                                                        @click.stop="toggleMenu('row_' + index)">
                                                    <i class="ri-more-2-fill"></i>
                                                </button>
                                                <ul v-show="openMenu === 'row_' + index" class="ag-menu">
                                                    <li>
                                                        <button @click="btnmodifier(datavalue);openMenu=null" class="ag-menu-item">
                                                            <i class="ri-pen-nib-line cf-menu-icon"></i> Modifier
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button @click="btnsuppression(datavalue);openMenu=null" class="ag-menu-item ag-menu-item--danger">
                                                            <i class="ri-delete-bin-line cf-menu-icon"></i> Supprimer
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </template>

                                <!-- Empty -->
                                <template v-else>
                                    <tr>
                                        <td colspan="20">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-search-eye-line"></i></div>
                                                <p class="empty-state__title">Aucun enregistrement trouvé</p>
                                                <p class="empty-state__sub">Essayez de modifier vos critères de recherche.</p>
                                            </div>
                                        </td>
                                    </tr>
                                </template>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="footer-bar">
                        <p class="footer-info">&nbsp;</p>

                        <nav v-if="pages.length > 1" class="pagination" aria-label="Page navigation">
                            <button @click="page--" :disabled="page <= 1" class="page-btn page-btn--nav"><i class="ri-arrow-left-s-line"></i></button>
                            <template v-for="(pageNumber, key) in displayedPages" :key="key">
                                <span v-if="pageNumber === '...'" style="padding:0 4px;color:var(--cf-faint);font-size:13px;">…</span>
                                <button v-else @click="page = pageNumber" :class="['page-btn', pageNumber === page ? 'page-btn--active' : '']">{{ pageNumber }}</button>
                            </template>
                            <button @click="page++" :disabled="page >= pages.length" class="page-btn page-btn--nav"><i class="ri-arrow-right-s-line"></i></button>
                        </nav>

                        <button @click="close" type="button" class="ti-btn ti-btn-danger-full">
                            <i class="ri-close-line align-middle"></i> Fermer
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <!-- Sub-modals -->
    <modalform ref="modalform" @closed="load"></modalform>
    <modalformsuppression @closed="load" ref="modalformsuppression"></modalformsuppression>

</template>

<script>
    /* import templatesite from "@/components/template/apptemplate";
     import appheader from "@/components/template/appheader";
     import appsidebar from "@/components/template/appsidebar";*/


    const axios =require('axios');

    import modalform from "@/components/views/pages/setting/caisse/form";
    import modalformsuppression from "@/components/views/pages/setting/caisse/formsuppression";


    import { randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            /*  searchtrierletableau: function(newvalue,oldvalue){

                  this.page=1

                  // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
                  // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

              }*/

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.intitulecaisse.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalform,modalformsuppression

        },

        data() {
            return {
                isdisplay:false,
                openMenu:null,
                titlemodal:"",
                datatable:[],
                quota:{ max:1, used:0, atteint:false },
                listedupersonnel:[],
                otherdata:[],
                datatiers:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                niveaudacces:{},





                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {

            // ── Menu 3-points (charte : un seul menu ouvert + clic extérieur) ──
            toggleMenu(key) {
                this.openMenu = this.openMenu === key ? null : key;
            },

            handleGlobalClick(e) {
                if (!e.target.closest('.ti-btn-group')) {
                    this.openMenu = null;
                }
            },

            mtypedecaisse (numid) {

                if (numid===0){
                    return "Auxiliaire"
                }

                if (numid===1){
                    return "Principale"
                }


            },


            btnajouter(){

                if (this.quota.used >= this.quota.max){
                    toastr['error']("Limite de caisses atteinte ("+this.quota.used+"/"+this.quota.max+"). Contactez votre support.","<b></b>");
                    return;
                }

                let mname

                let  Item= {
                    pid:'',
                    beartoken:'',
                    codecaisse:'',
                    intitulecaisse:'',
                    typedecaisse:0,
                    numerodecomptecomptable:'',
                    comptecomptable:null,
                    boutique:{
                        btk1:null,
                        btk2:null,
                        btk3:null,
                        btk4:null
                    },
                    params:{
                        param1:null,
                        param2:null,
                        param3:null,
                        param4:null,
                    },
                    usecaisse:0

                };

                mname='Enregistrer une caisse';

                this.$refs.modalform.show(mname,"add",Item,this.niveaudacces,this.otherdata);

            },



            async loadreturnotherdata(){

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl7admincaissee771714dfe/caisse/other884848484888/'+this.$store.state.appsociete+'/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.otherdata=[];

                            t.otherdata=res.data.otherdata;

                            // JwtService.setVALUEDATAPRICE(JSON.stringify(t.datainputlibelleforms))

                        }
                        else{
                            t.otherdata=[];

                        }


                    })
                    .catch((error)=>{

                        t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                //  }



            },

            async load(){



                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl7admincaissee771714dfe/caisse/'+this.$store.state.appsociete+'/895418initcaisse519151911515/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.datatable=[];
                            t.niveaudacces=res.data.niveaudacces;
                            if(res.data.quota) t.quota=res.data.quota;
                            t.datatable=res.data.m;
                            //t.alldata=res.data.alldata;
                            t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];
                            // t.alldata=[];

                            t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                        t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            btnmodifier(value){


                let titlemodal="Modifier l'enregistrement "+value.intitulecaisse

                let Item=value

                this.$refs.modalform.show(titlemodal,"update",Item,value.niveaudacces,this.otherdata);

            },

            btnsuppression(value){

                if (value.usecaisse===1 || value.usecaisse==='1'){

                    toastr['error']( "Impossible de supprimer cette ligne. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT SUPPRIMER "+value.intitulecaisse+" ?";

                this.$refs.modalformsuppression.show(titlemodal,value,this.typedoc);

            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },


            show(){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Liste des caisses"
                /* this.datatable=listdata
                 */


                this.loadreturnotherdata()
                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {
            document.addEventListener('click', this.handleGlobalClick)
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick)
        }




    }
</script>

<style scoped>
/* ------------------------------------------------------------------ *
 * Charte cf-/ds- : couleurs via tokens (var(--cf-*), rgb(var(--...))). *
 * Light-only.                                                        *
 * ------------------------------------------------------------------ */

/* ===== MODALE ===== */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1100px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:0.9rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }

/* ===== TOOLBAR ===== */
.toolbar { flex-shrink:0; padding:0.75rem 1rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); }
.toolbar-row { display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.search-wrap { position:relative; flex:1; min-width:200px; max-width:400px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.toolbar-actions { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

/* Compteur licence */
.set-quota { display:inline-flex; align-items:center; gap:4px; padding:6px 10px; border-radius:999px;
    border:1px solid var(--cf-border); background:#fff; font-size:0.75rem; color:var(--cf-muted); font-weight:600; }
.set-quota b { color:var(--cf-ink-strong); font-weight:800; }
.set-quota--full { border-color:#fecaca; background:#fef2f2; color:rgb(var(--danger)); }
.set-quota--full b { color:rgb(var(--danger)); }

/* Select "par page" */
.perpage-wrap { position:relative; display:inline-flex; align-items:center; }
.perpage-select { height:36px; padding:0 28px 0 12px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    background:#fff; color:var(--cf-ink); font-size:0.8rem; font-weight:600; appearance:none; outline:none; cursor:pointer; transition:all .2s; }
.perpage-select:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.perpage-caret { position:absolute; right:8px; pointer-events:none; color:var(--cf-faint); font-size:1rem; }

/* Menu 3 points */
.ag-menu { position:absolute; top:calc(100% + 4px); right:0; z-index:30; min-width:180px; margin:0; padding:0.3rem; list-style:none;
    background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); box-shadow:var(--cf-shadow-md); }
.ag-menu-item { display:flex; align-items:center; width:100%; padding:0.45rem 0.6rem; border:0; background:transparent; font-size:0.8rem;
    color:var(--cf-ink); text-align:left; cursor:pointer; border-radius:var(--cf-radius-xs); white-space:nowrap; }
.ag-menu-item:hover { background:var(--cf-surface-alt); }
.ag-menu-item--danger { color:rgb(var(--danger)); }
.ag-menu-item--danger .cf-menu-icon { color:rgb(var(--danger)); }

/* ===== TABLE ===== */
.table-zone { flex:1; overflow:hidden; padding:0; }
.table-scroll-wrap { overflow:auto; }
.set-scroll { height:52vh; }
@media (max-width:768px) { .set-scroll { height:auto; max-height:70vh; } }
.set-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:600px; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink);
    background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.row-number { color:var(--cf-faint); font-variant-numeric:tabular-nums; }

.avatar--sm { width:34px; height:34px; min-width:34px; background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); border-radius:var(--cf-radius-sm);
    display:flex; align-items:center; justify-content:center; font-size:0.9rem; font-weight:700; }

/* pastille cf-st (fallback si charte.css absente) */
.cf-st { display:inline-block; font-size:0.66rem; font-weight:700; padding:2px 9px; border-radius:999px; }
.cf-st--info { background:#dbeafe; color:#1d4ed8; }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0 0 6px; }
.empty-state__sub { font-size:0.82rem; color:var(--cf-muted); margin:0; }

/* ===== FOOTER / PAGINATION ===== */
.footer-bar { flex-shrink:0; display:flex; align-items:center; justify-content:space-between; padding:0.75rem 1rem;
    border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-wrap:wrap; gap:12px; }
.footer-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }
.pagination { display:flex; align-items:center; gap:4px; }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm);
    background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* ===== TRANSITIONS ===== */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } }

/* Scrollbar fine */
.set-scroll::-webkit-scrollbar { width:6px; height:6px; }
.set-scroll::-webkit-scrollbar-track { background:transparent; }
.set-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }
.set-scroll::-webkit-scrollbar-thumb:hover { background:#94a3b8; }
</style>
